import React, {useState, useEffect} from "react"
import { contentModelToBlock } from "../../util/contentModelToData"
import Head from "../Head"
import App from "../App"
import Hero from "../organisms/Hero"
import { HeaderThemeContext, headerThemes } from "../../context"
import { markdownToJSX } from "../../util/transforms"
import { getCurrentLocale } from '../../api/index'
import useSiteData from "../../useSiteData"

export default ({ pageContext }) => {
  const { 
    heroImage, 
    heroVideo, 
    heroLabel, 
    heroTitle, 
    title, 
    intro, 
    blocks, 
    metaDataTitle, 
    metaDataDescription, 
    metaDataImage, 
    canonicalSlug, 
    slugs, 
    topBannerActive, 
    topBannerText, 
    pagePath,
    metaDataRobots
  } = pageContext
  const [canonical, setCanonical] = useState(null)
  const heroHeading = heroLabel ? (heroLabel + ( heroTitle ? ( ' - ' + heroTitle ) : '' ) ) : heroTitle
  const headTitle = metaDataTitle || ( ( heroHeading || title ) + ' - Lapoint Surf camps')
  const theme = (heroImage || heroVideo) ? headerThemes.LIGHT : headerThemes.DARK
  const { translations } = useSiteData().pageSettings

  const banner = {
    active: topBannerActive || false,
    text: topBannerText || ""
  }

  useEffect(() => {
    (canonicalSlug) ? setCanonical(canonicalSlug) : setCanonical(null)
  },[canonicalSlug])

  return (
    <HeaderThemeContext.Provider value={{ theme }}>
      <App banner={banner}>
        <Head title={ headTitle } description={ metaDataDescription } image={ metaDataImage } canonical={ canonical } slugs={ slugs } pagePath={ pagePath } robots={ metaDataRobots }/>
        <main>
          { (heroImage || heroVideo || heroLabel || heroTitle) &&
            <Hero image={ heroImage } video={ heroVideo } label={ heroLabel } title={ heroTitle }/>
          }
          <section className="u-container u-container--medium u-section-spacing u-center-text">
            { (heroImage || heroVideo || heroLabel || heroTitle) ?
              <h2 className={"a-heading-large"}>{ markdownToJSX(title) }</h2> :
              <h1>{ markdownToJSX(title) }</h1>
            }
            { intro && <p className="a-preamble">{ intro }</p> }
          </section>
          { blocks && blocks.map((block, index) => contentModelToBlock(block, index, { translations })) }
        </main>
      </App>
    </HeaderThemeContext.Provider>
  )
}
